<app-login-header></app-login-header>
<div class="container page-content">
  <div class="template-detail">
    <form [formGroup]="otpForm" class="example-form">
      
      <p class="center-bold-text">Verify Email Address</p>
      <p class="center-normal-text">Please enter the OTP we've sent to {{ userId }}</p> 
      <div class="mb-4 ">
        <div class="d-flex justify-content-center">
          <mat-form-field class="" appearance="outline">
          <mat-label class="form-label" for="otp">Enter valid OTP</mat-label>
          <input matInput formControlName="otp" [errorStateMatcher]="matcher" required class="form-control">
          <mat-error class="error-message" *ngIf="otpForm.get('otp')?.hasError('required') && (otpForm.get('otp')?.dirty || otpForm.get('otp')?.touched)">
            OTP is required
          </mat-error>
        </mat-form-field>
          <a href="#" (click)="onResendOtp($event)" class="resend-otp-align">Resend OTP</a>
        </div>
      </div>
      
       <mat-error>{{ otpFailedMessage }}</mat-error> 
      <div class="mb-4">
      <div class="d-flex justify-content-center mb-4 mt-4">
        <button mat-flat-button type="button" id="submit" class="btn btn-primary" [disabled]="otpForm.invalid" (click)="onSubmit()">Verify</button>
      </div>
    </div>
     
    </form>
  </div>
</div>
<app-footer></app-footer>
